module.exports = __webpack_public_path__ + "img/aw-desktop-hover.07573bf5.png";